import React from 'react';
import { 
  VideoHero, 
  BrandsSection, 
} from './products/index';

const Marcas = () => {
  return (
    <section id="productos" className="bg-gradient-to-br from-gray-50 to-green-50">
      <VideoHero />
      <BrandsSection />
    </section>
  );
};

export default Marcas;